export default __webpack_public_path__ + "static/icon_xichi_green-1ce064cc5c2bd176febfbde39326c76a.svg";